import React, { Component } from 'react';

const STATUS = {
	INITIAL: 1,
	1: 'INITIAL',
	LOADING: 2,
	2: 'LOADING',
	LOADED: 3,
	3: 'LOADED',
	FAIL: 4,
	4: 'FAIL',
}

class DataProvider extends Component {
	childNode = null;
	children = [];

	liveRefresh() {
		let apiURL = process.env.GATSBY_ZMS_API_URL;
		if (this.props.url !== undefined && /https?:/.test(this.props.url) === false)apiURL += this.props.url;
		if (this.props.url !== undefined && /https?:/.test(this.props.url) === true)apiURL = this.props.url;
		if (this.props.model !== undefined) {
			apiURL += `${(this.props.namespace !== undefined ? this.props.namespace+'/' : '')}${this.props.model}/${(this.props.method !== undefined ? this.props.method : 'all')}/`;
		}
		if (this.props.type) {
			apiURL += `${this.props.type.split(/(?=[A-Z])/).map(item => item.toLowerCase()).join('/')}/${(this.props.method !== undefined ? this.props.method : 'all')}/`;
		}
		if (/https?:/.test(this.props.url) === false || this.props.model !== undefined) {
			let { apiParams } = this.props;
			if (!!apiParams === false)apiParams = {};
			const keys = Object.keys(apiParams);
			let queryString = keys.map(key => `${key}=${apiParams[key]}`).join('&');
			queryString += `&_lang=${this.state.lang}&_joinLang=${this.state.lang}`;
			apiURL += `?${queryString}`;
		}
		fetch(apiURL)
			.then(response => {
				if (response.status !== 200)throw response.statusText;
				return response.json();
			})
			.then(json => {
				this.setState({
					status: STATUS.LOADED,
					statusText: STATUS[STATUS.LOADED],
					response: json,

				})
			})
			.catch(err => {
				this.setState({
					status: STATUS.FAIL,
					statusText: STATUS[STATUS.FAIL],
				})
			});
	}

	constructor(props) {
		super(props);
		const children = React.Children.toArray(props.children);
		if (children.length)this.childNode = children[0];
		else this.childNode = null;
		this.state = {
			status: STATUS.INITIAL,
			statusText: STATUS[STATUS.INITIAL],
			response: {
				data: [],
			},
			lang: props.lang||'en',
		};
		this.liveRefresh = this.liveRefresh.bind(this);
	}

	componentDidMount() {
		if (this.props.liveRefresh !== false) {
			this.liveRefresh();
		}
	}

	render() {
		let returnObj;
		if (this.props.single) {
			returnObj = this.state.response.data[0];
		}
		else {
			returnObj = {
				providerResponse: this.state.response,
				providerStatus: this.state.status,
				providerStatusText: this.state.statusText,
			}
		}
		if (this.childNode !== null && this.props.loop === true) {
			this.children = [];
			for (let data of this.state.response.data) {
				this.children.push(React.cloneElement(this.childNode, { ...data}));
			}
			return this.children;
		} else if (this.childNode !== null) {
			return React.cloneElement(this.childNode, returnObj);
		}
		return this.props.render(returnObj);
	}
}

export default DataProvider;